import CryptoJS from 'crypto-js'

const generateDeviceToken = (name, email) => {
  const randomString = CryptoJS.lib.WordArray.random(16).toString()
  const data = `${name}-${email}-${randomString}`
  return CryptoJS.SHA256(data).toString()
}

export default generateDeviceToken
